var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7,
    height: 22.7,
    viewBox: "0 0 22.7 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle",
    transform: "translate(-1.15 -0.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745",
    transform: "translate(2 1.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    d: "M10.5-.85A11.35,11.35,0,0,1,21.85,10.5,11.35,11.35,0,0,1,2.474,18.526a11.35,11.35,0,0,1,0-16.051A11.276,11.276,0,0,1,10.5-.85Zm0,21A9.65,9.65,0,1,0,.85,10.5,9.661,9.661,0,0,0,10.5,20.15Z",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M16.224,12.95H8a.95.95,0,0,1,0-1.9h8.224a.95.95,0,0,1,0,1.9Z",
    transform: "translate(-1.832 -1.567)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleIcon);
export default __webpack_public_path__ + "static/media/minus-circle-icon.43bd0fdcbe3309217450e7eaaf02da40.svg";
export { ForwardRef as ReactComponent };